document.addEventListener('DOMContentLoaded', function () {
    const pageContainer = document.querySelector('.lh-container');
    let gridEl  = document.querySelector('#lh-list .lh-grid');
    let pagerEl = document.querySelector('#lh-list .lh-pagination');
    const countEl = document.getElementById('lh-count');
    const countElBottom = document.getElementById('lh-count-bottom');
    const filtersPanel = document.getElementById('lh-filters');
    const activeChipsBox = document.getElementById('lh-active-filters');

    // Global request state for debouncing & cancellation
    let _requestState = { controller: null, id: 0 };

    // Detect page type from container or filtersPanel, fallback to ''
    const pageType = (
        (pageContainer?.dataset.pageType) ||
        (filtersPanel?.dataset.mode) ||
        (document.body?.dataset.pageType) ||
        ''
    ).toString().trim().toLowerCase();
    console.debug('[LH] pageType:', pageType);
    const IS_SEARCH_PAGE = location.pathname.replace(/\/+$/, '') === '/search';

    // Normalizer and tag helpers for client-side filtering
    const norm = (s) => (s || '').toString()
        .toLowerCase()
        .replace(/\s*:\s*/g, ':')
        .replace(/[-_]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    const hasTag = (tags, wanted) => tags.includes(norm(wanted));
    const pick = (tags, prefix) => tags.filter(t => t.startsWith(prefix + ':')).map(t => t.replace(prefix + ':','').trim());

    const MOBILE_MQ = window.matchMedia('(max-width: 1024px)');
    const portalState = { isPortaled: false, placeholder: null };
    function setVH(){ document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`); }


    function portalizeFilters(){
        if (!filtersPanel || portalState.isPortaled) return;

        portalState.placeholder = document.createComment('lh-filters-placeholder');
        if (filtersPanel.parentNode) {
            filtersPanel.parentNode.insertBefore(portalState.placeholder, filtersPanel);
        }
        document.body.appendChild(filtersPanel);
        filtersPanel.classList.add('as-portal');
        portalState.isPortaled = true;
        setVH();
        window.addEventListener('resize', setVH);
    }

    function initEducationYearsFilter() {
        const yearsBox = document.getElementById('edu-years');
        if (!yearsBox) return;

        // Add "All" option at the top and wire its behavior (reuse common helpers)
        ensureAllOption(yearsBox, 'All');
        wireAllBehavior(yearsBox);

        function getPickedYearsFromURL() {
            const qs = new URLSearchParams(location.search);
            return (qs.get('years') || '')
                .split(',')
                .map(s => s.trim())
                .filter(Boolean);
        }

        function applyPickedYears(picked) {
            const allCb = yearsBox.querySelector('input[type="checkbox"][data-all="true"]');

            // Sync checkboxes from picked array
            [...yearsBox.querySelectorAll('input[type="checkbox"]')].forEach(cb => {
                if (cb.dataset.all === 'true') return;
                cb.checked = picked.includes(cb.value);
            });

            // Determine "All" state
            const anyItemChecked = [...yearsBox.querySelectorAll('input[type="checkbox"]:not([data-all="true"])')].some(cb => cb.checked);
            if (allCb) allCb.checked = !anyItemChecked;

            const allSections = [...document.querySelectorAll('.edu-year')];

            // If "All" is checked or nothing explicitly picked → show all
            if (!anyItemChecked || (allCb && allCb.checked)) {
                allSections.forEach(sec => { sec.style.display = ''; });
                return;
            }

            // Otherwise show only selected years
            allSections.forEach(sec => {
                const labelEl = sec.querySelector('summary span');
                const yearLabel = labelEl ? labelEl.textContent.trim() : '';
                sec.style.display = picked.includes(yearLabel) ? '' : 'none';
            });
        }

        const pickedOnLoad = getPickedYearsFromURL();
        applyPickedYears(pickedOnLoad);
        renderActiveChips();

        const yearDetails = [...document.querySelectorAll('.edu-year')];
        yearDetails.forEach((d, idx) => { if (idx > 0) d.removeAttribute('open'); });

        yearsBox.addEventListener('change', (evt) => {
            // Prevent global filtersPanel change handler from firing in education mode
            evt.stopPropagation();

            const picked = [...yearsBox.querySelectorAll('input[type="checkbox"]:checked')]
                .filter(i => i.dataset.all !== 'true')
                .map(i => i.value);

            const url = new URL(location.href);
            if (picked.length) url.searchParams.set('years', picked.join(','));
            else url.searchParams.delete('years');

            history.replaceState(null, '', url.toString());
            applyPickedYears(picked);
            renderActiveChips();

        });
    }

    function showAllEducationSections() {
        document.querySelectorAll('.edu-year').forEach(sec => { sec.style.display = ''; });
    }
    function clearEducationYearsSelection() {
        const yearsBox = document.getElementById('edu-years');
        if (yearsBox) {
            yearsBox.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
        }
        const url = new URL(location.href);
        url.searchParams.delete('years');
        history.replaceState(null, '', url.toString());
        showAllEducationSections();
    }

    function deportalizeFilters(){
        if (!filtersPanel || !portalState.isPortaled) return;
        if (portalState.placeholder && portalState.placeholder.parentNode) {
            portalState.placeholder.parentNode.insertBefore(filtersPanel, portalState.placeholder);
            portalState.placeholder.remove();
        }
        filtersPanel.classList.remove('as-portal');
        portalState.placeholder = null;
        portalState.isPortaled = false;
        document.body.classList.remove('filter-is-open');
        filtersPanel.classList.remove('is-open');
        document.body.style.overflow = '';
        filtersPanel.style.height = '';
        filtersPanel.style.transform = '';
        window.removeEventListener('resize', setVH);
    }

    function syncFiltersPortal(){
        if (!filtersPanel) return;
        if (MOBILE_MQ.matches) {
            portalizeFilters();
        } else {
            deportalizeFilters();
        }
    }

    if (filtersPanel) {
        syncFiltersPortal();
        if (typeof MOBILE_MQ.addEventListener === 'function') {
            MOBILE_MQ.addEventListener('change', syncFiltersPortal);
        } else if (typeof MOBILE_MQ.addListener === 'function') {
            MOBILE_MQ.addListener(syncFiltersPortal);
        }
    }

    const openBtn = document.getElementById('lh-open-filters');
    const closeBtn = document.getElementById('lh-close-filters');
    const clearBtn = document.getElementById('lh-clear-filters');
    const applyBtn = document.querySelector('#lh-apply-filters[data-action="apply-filters"]');

    function openFilters() {
        if (!filtersPanel) return;
        if (MOBILE_MQ.matches && !portalState.isPortaled) portalizeFilters();
        document.body.classList.add('filter-is-open');
        filtersPanel.classList.add('is-open');
        document.body.style.overflow = 'hidden';
    }

    function closeFilters() {
        if (!filtersPanel) return;
        filtersPanel.classList.remove('is-open');
        document.body.classList.remove('filter-is-open');
        document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', openFilters);
    if (closeBtn) closeBtn.addEventListener('click', closeFilters);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeFilters(); });

    if (clearBtn) clearBtn.addEventListener('click', () => {
        if (pageType === 'education') {
            clearEducationYearsSelection();
            return;
        }

        document.querySelectorAll('#f-types input:checked, #f-topics input:checked, #f-access:checked')
            .forEach(inp => { inp.checked = false; });
        const ingBox = document.getElementById('f-ingredients');
        if (ingBox) ingBox.querySelectorAll('label.lh-chip').forEach(ch => ch.remove());

        const ghost = document.createElement('input');
        ghost.type = 'hidden';
        filtersPanel.appendChild(ghost);
        ghost.dispatchEvent(new Event('change', {bubbles: true}));
        filtersPanel.removeChild(ghost);
    });

    if (applyBtn) applyBtn.addEventListener('click', () => {
        closeFilters();
        if (pageType === 'education') return;
        if (typeof loadArticles === 'function') loadArticles(1);
    });

    if (pageType === 'education') {
        initEducationYearsFilter();
        return;
    }
    bindServerPagerClicks(pagerEl);
    setTimeout(() => bindServerPagerClicks(document.querySelector('.lh-pagination')), 0);
    const topicsBox = document.getElementById('f-topics');
    const ingBox = document.getElementById('f-ingredients');
    const typesBox = document.getElementById('f-types');
    const accessInput = document.getElementById('f-access');
    const searchInput = document.getElementById('lh-q');

    const perPage = parseInt(document.getElementById('lh-list')?.dataset.perPage || '12', 10);
    const blogHandle = (pageContainer?.dataset.blogHandle && pageContainer.dataset.blogHandle !== '{{ target_handle }}')
        ? pageContainer.dataset.blogHandle
        : ((location.pathname.split('/blogs/')[1] || '').split('/')[0]);

    function _blogFromUrl(u) {
        try {
            const url = new URL(u, location.origin);
            const seg = url.pathname.split('/').filter(Boolean); // e.g. ["blogs","metagenics-institute","article-handle"]
            const i = seg.indexOf('blogs');
            return (i >= 0 && seg[i + 1]) ? seg[i + 1] : '';
        } catch (_) { return ''; }
        }
    // Required tag from current URL (for cross-blog filtering)
    const REQUIRED_TAG = (new URL(location.href)).searchParams.get('tag') || '';

    function ensureAllOption(listEl, label = 'All') {
        if (!listEl) return;
        if (listEl.querySelector('input[data-all="true"]')) return;
        const li = document.createElement('li');
        li.innerHTML = `
    <label class="cb">
      <input type="checkbox" data-all="true" value="__ALL__" checked>
      <span class="cb-box" aria-hidden="true"></span>
      <span class="cb-text">${label}</span>
    </label>
  `;
        listEl.insertBefore(li, listEl.firstChild);
    }

    function wireAllBehavior(listEl) {
        if (!listEl) return;
        listEl.addEventListener('change', (e) => {
            const target = e.target;
            if (!target || target.type !== 'checkbox') return;

            const allCb = listEl.querySelector('input[type="checkbox"][data-all="true"]');
            const itemCbs = [...listEl.querySelectorAll('input[type="checkbox"]:not([data-all="true"])')];
            const anyItemChecked = itemCbs.some(cb => cb.checked);

            if (target === allCb) {
                if (allCb.checked) itemCbs.forEach(cb => (cb.checked = false));
            } else {
                if (target.checked && allCb) allCb.checked = false;
                if (!anyItemChecked && allCb) allCb.checked = true;
            }
        });
    }

    function dispatchNativeChange(el){
        if (!el) return;
        el.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function getChecked(container){
        if (!container) return [];
        return [...container.querySelectorAll('input[type="checkbox"]:checked')]
            .filter(cb => cb.dataset.all !== 'true')
            .map(cb => ({ value: (cb.value || '').trim(), input: cb }));
    }

    function getIngredientChips(){
        const box = document.getElementById('f-ingredients');
        if (!box) return [];
        return [...box.querySelectorAll('label.lh-chip input[type="checkbox"]')].map(cb => ({
            value: (cb.value || '').trim(),
            input: cb
        }));
    }

    function getEducationYears(){
        const box = document.getElementById('edu-years');
        if (!box) return [];
        return [...box.querySelectorAll('input[type="checkbox"]:checked')]
            .filter(cb => cb.dataset.all !== 'true')
            .map(cb => ({ value: (cb.value || '').trim(), input: cb, group: 'years' }));
    }

    function currentSelectionsForChips(){
        const items = [];
        // Removed access chip block
        getChecked(document.getElementById('f-types')).forEach(({value, input}) => {
            items.push({ label: value, value, input, group: 'types' });
        });
        getChecked(document.getElementById('f-topics')).forEach(({value, input}) => {
            items.push({ label: value, value, input, group: 'topics' });
        });

        getEducationYears().forEach(item => {
            items.push({ label: item.value, value: item.value, input: item.input, group: 'years' });
        });
        return items;
    }

    function renderActiveChips(){
        if (!activeChipsBox) return;
        const sel = currentSelectionsForChips();
        const selectedNoAccess = sel.filter(item => item.group !== 'access');

        if (!selectedNoAccess.length){
            activeChipsBox.innerHTML = '';
            activeChipsBox.hidden = true;
            return;
        }

        const frag = document.createDocumentFragment();
        const wrap = document.createElement('div');
        wrap.className = 'lh-active-filters__list';

        selectedNoAccess.forEach(item => {
            // Create a non-interactive chip container
            const chip = document.createElement('div');
            chip.className = 'lh-active-chip';
            chip.setAttribute('data-group', item.group || '');
            chip.setAttribute('data-value', item.value);

            const labelSpan = document.createElement('span');
            labelSpan.className = 'lh-active-chip__label';
            labelSpan.textContent = item.label;

            const xBtn = document.createElement('button');
            xBtn.type = 'button';
            xBtn.className = 'lh-active-chip__x';
            xBtn.setAttribute('aria-label', 'Remove');
            xBtn.setAttribute('title', 'Remove');
            xBtn.textContent = '×';

            xBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                if (item.group === 'years'){
                    if (item.input){
                        item.input.checked = false;
                        dispatchNativeChange(item.input);
                    }
                } else if (item.group === 'access'){
                    item.input.checked = false;
                    dispatchNativeChange(item.input);
                } else {
                    if (item.input){
                        item.input.checked = false;
                        dispatchNativeChange(item.input);
                    }
                }

                if (pageType === 'education'){
                    const yrsBox = document.getElementById('edu-years');
                    if (yrsBox){
                        const picked = [...yrsBox.querySelectorAll('input[type="checkbox"]:checked')]
                            .filter(i => i.dataset.all !== 'true').map(i => i.value);
                        const url = new URL(location.href);
                        if (picked.length) url.searchParams.set('years', picked.join(','));
                        else url.searchParams.delete('years');
                        history.replaceState(null, '', url.toString());

                        const any = picked.length > 0;
                        document.querySelectorAll('.edu-year').forEach(sec => {
                            const labelEl = sec.querySelector('summary span');
                            const y = labelEl ? labelEl.textContent.trim() : '';
                            sec.style.display = (!any || picked.includes(y)) ? '' : 'none';
                        });
                    }
                } else {
                    // No direct loadArticles here; inputs' change events will trigger debounced reload
                }

                setTimeout(renderActiveChips, 0);
            });

            chip.appendChild(xBtn);
            chip.appendChild(labelSpan);
            wrap.appendChild(chip);
        });

        frag.appendChild(wrap);
        activeChipsBox.innerHTML = '';
        activeChipsBox.appendChild(frag);
        activeChipsBox.hidden = false;
    }

    function getCheckedValuesWithoutAll(containerSelector) {
        return [...document.querySelectorAll(`${containerSelector} input[type="checkbox"]:checked`)]
            .filter(inp => !inp.dataset.all)
            .map(inp => (inp.value || '').trim());
    }

    function applyValuesWithAll(listEl, values) {
        if (!listEl) return;
        const allCb = listEl.querySelector('input[type="checkbox"][data-all="true"]');
        const itemCbs = [...listEl.querySelectorAll('input[type="checkbox"]:not([data-all="true"])')];

        if (allCb) allCb.checked = false;
        itemCbs.forEach(cb => (cb.checked = false));

        if (Array.isArray(values) && values.length) {
            itemCbs.forEach(cb => {
                const v = (cb.value || '').trim().toLowerCase();
                if (values.some(val => String(val).trim().toLowerCase() === v)) cb.checked = true;
            });
            const any = itemCbs.some(cb => cb.checked);
            if (!any && allCb) allCb.checked = true;
        } else {
            if (allCb) allCb.checked = true;
        }
    }

    function ensureLoader() {
        gridEl = document.querySelector('.lh-grid') || gridEl;
        let el = document.getElementById('lh-loading');
        if (!el && gridEl) {
            el = document.createElement('div');
            el.id = 'lh-loading';
            el.className = 'lh-loading';
            el.hidden = true;
            el.innerHTML = '<div class="lh-spinner" aria-label="Loading" role="status"></div>';
            gridEl.appendChild(el);
        }
        return el;
    }

    function ensurePager() {
        // Try to find current pager
        pagerEl = document.querySelector('#lh-list .lh-pagination') || pagerEl;
        if (pagerEl) return pagerEl;
        // Create a pager container right after the grid
        const host = document.querySelector('#lh-list');
        if (!host) return null;
        const nav = document.createElement('nav');
        nav.className = 'lh-pagination';
        // Insert after grid, or at the end of host
        const grid = document.querySelector('#lh-list .lh-grid');
        if (grid && grid.parentNode) {
            grid.parentNode.insertBefore(nav, grid.nextSibling);
        } else {
            host.appendChild(nav);
        }
        pagerEl = nav;
        return pagerEl;
    }

    function showLoading() {
        const el = ensureLoader();
        if (el) el.hidden = false;
    }

    function hideLoading() {
        const el = document.getElementById('lh-loading');
        if (el) el.hidden = true;
    }

    const FACETS = window.__LH_FACETS__ || {topics: [], ingredients: [], types: []};

    function getEditorParams() {
        const qs = new URLSearchParams(location.search);
        return {
            preview: qs.get('preview_theme_id') || pageContainer?.dataset.previewThemeId || '',
            section: qs.get('section_id') || pageContainer?.dataset.sectionId || '',
            storeBrand: qs.get('store_brand') || ''
        };
    }

    function renderChecklist(container, values) {
        if (!container || !Array.isArray(values) || !values.length) return;
        if (container.children.length) return;
        const frag = document.createDocumentFragment();
        values.forEach((label) => {
            const li = document.createElement('li');
            li.innerHTML = `
      <label class="cb">
        <input type="checkbox" value="${String(label).trim()}">
        <span class="cb-box" aria-hidden="true"></span>
        <span class="cb-text">${label}</span>
      </label>
    `;
            frag.appendChild(li);
        });
        container.appendChild(frag);
    }

    function typesFromDOM(rootEl){
        if (!rootEl) return [];
        const tags = [...rootEl.querySelectorAll('.lh-card-wrap[data-tags]')]
            .flatMap(el => (el.getAttribute('data-tags') || '').split('|'))
            .map(s => String(s || '').trim())
            .filter(Boolean);
        const out = new Set();
        tags.forEach(t => {
            if (/^resource:/i.test(t)) {
                const raw = t.replace(/^resource:\s*/i, '').trim();
                if (raw) out.add(raw);
            }
        });
        return Array.from(out.values()).sort((a,b)=>a.localeCompare(b, undefined, {sensitivity:'base'}));
    }

    function topicsFromDOM(rootEl){
        if (!rootEl) return [];
        const tags = [...rootEl.querySelectorAll('.lh-card-wrap[data-tags]')]
            .flatMap(el => (el.getAttribute('data-tags') || '').split('|'))
            .map(s => String(s || '').trim())
            .filter(Boolean);
        const out = new Set();
        tags.forEach(t => {
            if (/^topic:/i.test(t)) {
                const raw = t.replace(/^topic:\s*/i, '').trim();
                if (raw) out.add(raw);
            }
        });
        return Array.from(out.values()).sort((a,b)=>a.localeCompare(b, undefined, {sensitivity:'base'}));
    }

    function ingredientsFromDOM(rootEl){
        if (!rootEl) return [];
        const tags = [...rootEl.querySelectorAll('.lh-card-wrap[data-tags]')]
            .flatMap(el => (el.getAttribute('data-tags') || '').split('|'))
            .map(s => String(s || '').trim())
            .filter(Boolean);
        const out = new Set();
        tags.forEach(t => {
            if (/^ingredient:/i.test(t)) {
                const raw = t.replace(/^ingredient:\s*/i, '').trim();
                if (raw) out.add(raw);
            }
        });
        return Array.from(out.values()).sort((a,b)=>a.localeCompare(b, undefined, {sensitivity:'base'}));
    }

    function buildTypesList(){
        const fromFacets = Array.isArray(FACETS.types) ? FACETS.types.slice() : [];
        const fromDom = typesFromDOM(document);
        const fromExisting = getTypeLabelsFromList(typesBox);
        return unionTypes(unionTypes(fromFacets, fromDom), fromExisting);
    }

    function buildTopicsList(){
        const fromFacets = Array.isArray(FACETS.topics) ? FACETS.topics.slice() : [];
        const fromDom = topicsFromDOM(document);
        const fromExisting = getTopicLabelsFromList(topicsBox);
        return unionTypes(unionTypes(fromFacets, fromDom), fromExisting);
    }

    function getTopicLabelsFromList(container){
        if (!container) return [];
        return [...container.querySelectorAll('input[type="checkbox"]:not([data-all="true"])')]
            .map(cb => (cb.value || '').trim())
            .filter(Boolean);
    }

    function renderTopicsChecklist(list){
        if (!topicsBox) return;
        const prevChecked = new Set(
            [...topicsBox.querySelectorAll('input[type="checkbox"]:checked')]
                .filter(cb => cb.dataset.all !== 'true')
                .map(cb => (cb.value || '').trim().toLowerCase())
        );

        topicsBox.innerHTML = '';
        renderChecklist(topicsBox, list);
        ensureAllOption(topicsBox, 'All');
        wireAllBehavior(topicsBox);

        if (prevChecked.size) {
            [...topicsBox.querySelectorAll('input[type="checkbox"]:not([data-all="true"])')].forEach(cb => {
                const v = (cb.value || '').trim().toLowerCase();
                if (prevChecked.has(v)) cb.checked = true;
            });
            const any = [...topicsBox.querySelectorAll('input[type="checkbox"]:not([data-all="true"])')].some(cb => cb.checked);
            const allCb = topicsBox.querySelector('input[type="checkbox"][data-all="true"]');
            if (allCb) allCb.checked = !any;
        }
    }

    function renderTypesChecklist(list){
        if (!typesBox) return;
        const prevChecked = new Set(
            [...typesBox.querySelectorAll('input[type="checkbox"]:checked')]
                .filter(cb => cb.dataset.all !== 'true')
                .map(cb => (cb.value || '').trim().toLowerCase())
        );

        typesBox.innerHTML = '';
        renderChecklist(typesBox, list);
        ensureAllOption(typesBox, 'All');
        wireAllBehavior(typesBox);

        if (prevChecked.size) {
            [...typesBox.querySelectorAll('input[type="checkbox"]:not([data-all="true"])')].forEach(cb => {
                const v = (cb.value || '').trim().toLowerCase();
                if (prevChecked.has(v)) cb.checked = true;
            });
            const any = [...typesBox.querySelectorAll('input[type="checkbox"]:not([data-all="true"])')].some(cb => cb.checked);
            const allCb = typesBox.querySelector('input[type="checkbox"][data-all="true"]');
            if (allCb) allCb.checked = !any;
        }
    }

    function getTypeLabelsFromList(container){
        if (!container) return [];
        return [...container.querySelectorAll('input[type="checkbox"]:not([data-all="true"])')]
            .map(cb => (cb.value || '').trim())
            .filter(Boolean);
    }
    function unionTypes(a, b){
        const out = new Set();
        (a || []).forEach(v => { if (v) out.add(String(v).trim()); });
        (b || []).forEach(v => { if (v) out.add(String(v).trim()); });
        return Array.from(out.values()).sort((x,y)=>x.localeCompare(y, undefined, {sensitivity:'base'}));
    }

    renderTopicsChecklist(buildTopicsList());

    renderTypesChecklist(buildTypesList());

    function createIngredientChip(label) {
        if (!ingBox) return;
        const val = String(label).trim();
        const exists = [...ingBox.querySelectorAll('input[type="checkbox"]')]
            .some(inp => (inp.value || '').trim().toLowerCase() === val.toLowerCase());
        if (exists) return;

        const wrap = document.createElement('label');
        wrap.className = 'lh-chip';
        wrap.innerHTML = `
        <input type="checkbox" value="${val}" checked>
        <span>${val}</span>
        <span class="lh-chip__remove" aria-label="Remove" title="Remove">×</span>
      `;
        const cbEl = wrap.querySelector('input[type="checkbox"]');
        if (cbEl) {
            cbEl.setAttribute('tabindex', '-1');
            cbEl.setAttribute('aria-hidden', 'true');
        }
        wrap.addEventListener('click', (ev) => {
            if (!(ev.target && ev.target.classList && ev.target.classList.contains('lh-chip__remove'))) {
                ev.preventDefault();
                ev.stopPropagation();
            }
        }, true);

        wrap.querySelector('.lh-chip__remove').addEventListener('click', (e) => {
            e.preventDefault();
            const cb = wrap.querySelector('input[type="checkbox"]');
            if (cb) {
                cb.checked = false;
                cb.dispatchEvent(new Event('change', {bubbles: true}));
            }
            wrap.remove();
        });
        ingBox.appendChild(wrap);
        wrap.querySelector('input[type="checkbox"]').dispatchEvent(new Event('change', {bubbles: true}));
    }

    (function setupIngredientsAutocomplete() {
        const ingSearch = document.getElementById('f-ing-search');
        if (!ingSearch) return;

        const acWrap = document.createElement('div');
        acWrap.className = 'lh-autocomplete';
        ingSearch.parentNode.insertBefore(acWrap, ingSearch);
        acWrap.appendChild(ingSearch);

        const panel = document.createElement('div');
        panel.className = 'lh-autocomplete__panel';
        const list = document.createElement('ul');
        list.className = 'lh-autocomplete__list';
        panel.appendChild(list);
        acWrap.appendChild(panel);

        const getAllIngredients = () => {
            const fromFacets = Array.isArray(FACETS.ingredients) ? FACETS.ingredients : [];
            const fromDom = ingredientsFromDOM(document);
            return unionTypes(fromFacets, fromDom);
        };

        function show(items) {
            list.innerHTML = '';
            if (!items.length) {
                panel.style.display = 'none';
                return;
            }
            items.slice(0, 100).forEach(label => {
                const li = document.createElement('li');
                li.className = 'lh-autocomplete__item';
                li.textContent = label;
                li.addEventListener('click', () => {
                    createIngredientChip(label);
                    ingSearch.value = '';
                    panel.style.display = 'none';
                    ingSearch.focus();
                });
                list.appendChild(li);
            });
            panel.style.display = 'block';
        }

        function filter(q) {
            const s = String(q || '').trim().toLowerCase();
            if (!s) {
                panel.style.display = 'none';
                return;
            }
            // Get currently selected ingredients
            const selected = [...(ingBox?.querySelectorAll('input[type="checkbox"]:checked') || [])]
                .map(inp => (inp.value || '').trim().toLowerCase());
            
            // Filter by search term AND exclude already selected
            const out = getAllIngredients().filter(l => {
                const label = l && l.toString().toLowerCase();
                return label && label.includes(s) && !selected.includes(label);
            });
            show(out);
        }

        ingSearch.addEventListener('input', e => filter(e.target.value));
        ingSearch.addEventListener('focus', e => filter(e.target.value));
        document.addEventListener('click', e => {
            if (!acWrap.contains(e.target)) panel.style.display = 'none';
        });
        ingSearch.addEventListener('keydown', e => {
            if (e.key === 'Escape') panel.style.display = 'none';
        });
    })();

    // Ensure clicks on ingredient chips do nothing unless on the "×"
    (function guardIngredientChipsClicks() {
        const ingBoxRoot = document.getElementById('f-ingredients');
        if (!ingBoxRoot) return;
        ingBoxRoot.addEventListener('click', (ev) => {
            const chip = ev.target && (ev.target.closest && ev.target.closest('label.lh-chip'));
            if (!chip) return;
            const isRemove = ev.target.classList && ev.target.classList.contains('lh-chip__remove');
            if (!isRemove) {
                ev.preventDefault();
                ev.stopPropagation();
            }
        }, true);
    })();

    function parseCsvParam(qs, key) {
        return (qs.get(key) || '').split(',').map(s => s.trim()).filter(Boolean);
    }

    const _initialQS = new URLSearchParams(location.search);
    const URL_SEED = {
        topics:       parseCsvParam(_initialQS, 'topics'),
        ingredients:  parseCsvParam(_initialQS, 'ingredients'),
        types:        parseCsvParam(_initialQS, 'types'),
        access:       _initialQS.get('access') === 'practitioner',
        q:            _initialQS.get('q') || '',
        page:         parseInt(_initialQS.get('page') || '1', 10) || 1
    };

    function checkBoxes(container, values) {
        if (!container || !values.length) return;
        const inputs = container.querySelectorAll('input[type="checkbox"]');
        values.forEach(val => {
            const v = val.toLowerCase();
            inputs.forEach(inp => {
                if ((inp.value || '').trim().toLowerCase() === v) inp.checked = true;
            });
        });
    }

    function setIngredientChipsFromURL(values) {
        if (!ingBox || !values || !values.length) return;
        values.forEach(v => createIngredientChip(v));
    }

    function syncFromURL() {
        {
            applyValuesWithAll(topicsBox, URL_SEED.topics || []);
            applyValuesWithAll(typesBox,  URL_SEED.types  || []);
            setIngredientChipsFromURL(URL_SEED.ingredients || []);

            if (accessInput) accessInput.checked = !!URL_SEED.access;
            if (searchInput && URL_SEED.q) searchInput.value = URL_SEED.q;

            const hasAny = (URL_SEED.topics && URL_SEED.topics.length)
                || (URL_SEED.ingredients && URL_SEED.ingredients.length)
                || (URL_SEED.types && URL_SEED.types.length)
                || !!URL_SEED.access
                || (URL_SEED.q && URL_SEED.q.trim());

            return { page: URL_SEED.page || 1, hasAny };
        }
    }

    function collectFilters() {
        {
            const types = typesBox ? getCheckedValuesWithoutAll('#f-types') : (URL_SEED.types || []);
            const topics = topicsBox ? getCheckedValuesWithoutAll('#f-topics') : (URL_SEED.topics || []);
            const ingredients = ingBox
                ? [...document.querySelectorAll('#f-ingredients input:checked')].map(el => el.value.trim())
                : (URL_SEED.ingredients || []);
            const access = accessInput ? !!document.querySelector('#f-access:checked') : !!URL_SEED.access;
            const qText = (searchInput ? (searchInput.value || '') : URL_SEED.q || '').trim();

            return { types, topics, ingredients, access, q: qText };
        }
    }

    function updateAddressBar(state, page) {
        const current = new URLSearchParams(location.search);
        const qs = new URLSearchParams(current.toString());

        const isSearch = location.pathname.replace(/\/+$/, '') === '/search';

        const setIfAny = (key, arrOrStr) => {
            if (Array.isArray(arrOrStr)) {
                if (arrOrStr.length) qs.set(key, arrOrStr.join(','));
                else qs.delete(key);
            } else {
                const v = (arrOrStr ?? '').toString().trim();
                if (v) qs.set(key, v);
                else qs.delete(key);
            }
        };

        const qFromInput = (typeof state.q === 'string') ? state.q.trim() : '';
        const qExisting  = current.get('q') || '';
        const qFinal     = isSearch ? (qFromInput || qExisting) : qFromInput;
        if (qFinal) qs.set('q', qFinal); else qs.delete('q');

        const typesForUrl  = state.types || [];
        const topicsForUrl = state.topics || [];
        const ingsForUrl   = state.ingredients || [];
        setIfAny('types',        typesForUrl);
        setIfAny('topics',       topicsForUrl);
        setIfAny('ingredients',  ingsForUrl);
        if (state.access) qs.set('access', 'practitioner'); else qs.delete('access');

        const p = parseInt(page || '1', 10) || 1;
        if (p > 1) qs.set('page', String(p)); else qs.delete('page');

        ['type', 'store_brand'].forEach((k) => {
            const v = current.get(k);
            if (v) qs.set(k, v);
        });
        current.forEach((v, k) => {
            if (k.startsWith('options[')) qs.set(k, v);
        });

        if (!isSearch) {
            const curView = current.get('view');
            if (curView) qs.set('view', curView);
        } else {
            qs.delete('view');
        }

        const newUrl = `${location.pathname}${qs.toString() ? '?' + qs.toString() : ''}${location.hash}`;
        history.replaceState(null, '', newUrl);
    }
    function buildSearchQuery({ topics, ingredients, types, access, q }) {
        const esc = (s) => String(s).trim().replace(/"/g, '\\"');
        const andParts = [];
      
        // Always limit to current blog context
        if (REQUIRED_TAG) {
          andParts.push(`tag:"${esc(REQUIRED_TAG)}"`);
        }
      
        // OR logic within groups
        const topicClauses = (topics || []).map(t => `tag:"topic:${esc(t)}"`);
        const ingredientClauses = (ingredients || []).map(i => `tag:"ingredient:${esc(i)}"`);
        const typeClauses = (types || []).map(t => `tag:"resource:${esc(t)}"`);
      
        // Only add if there are selections
        if (topicClauses.length) andParts.push(`(${topicClauses.join(' OR ')})`);
        if (ingredientClauses.length) andParts.push(`(${ingredientClauses.join(' OR ')})`);
        if (typeClauses.length) andParts.push(`(${typeClauses.join(' OR ')})`);
      
        if (access) {
          andParts.push(`(tag:"access:practitioner" OR tag:"Access:Practitioner")`);
        }
      
        if (q && q.trim()) {
          andParts.push(q.trim());
        }
      
        // Return the AND-joined query
        return andParts.join(' ').trim();
      }

    function setCount(total, page, perPage) {
        const targets = [document.getElementById('lh-count'), document.getElementById('lh-count-bottom')].filter(Boolean);
        if (!targets.length) return;

        let text = 'No results';
        if (Number(total) > 0) {
            const start = (page - 1) * perPage + 1;
            const end = Math.min(page * perPage, total);
            text = `Displaying ${start} - ${end} of ${total}`;
        }
        targets.forEach(el => el.textContent = text);

        // Update search query text with correct count
        const lhQueryEl = document.getElementById('lh-query');
        if (lhQueryEl) {
            const searchTerms = lhQueryEl.dataset.searchTerms || '';
            if (Number(total) > 0) {
                lhQueryEl.textContent = `${total} search results for '${searchTerms}'`;
            } else {
                lhQueryEl.textContent = `No search results for '${searchTerms}'`;
            }
        }
    }

    function clientPagination(total, page, perPage) {
        const pages = Math.ceil((total || 0) / (perPage || 1));
        if (pages <= 1) return '';
        const prev = Math.max(1, page - 1);
        const next = Math.min(pages, page + 1);
        let html = '<nav class="lh-pagination" role="navigation" aria-label="Pagination"><ul>';
        html += `<li>${page > 1 ? `<a href="#" data-page="${prev}">‹</a>` : '<span class="is-disabled">‹</span>'}</li>`;
        for (let p = 1; p <= pages; p++) {
            html += p === page ? `<li><span class="is-current">${p}</span></li>` : `<li><a href="#" data-page="${p}">${p}</a></li>`;
        }
        html += `<li>${page < pages ? `<a href="#" data-page="${next}">›</a>` : '<span class="is-disabled">›</span>'}</li>`;
        html += '</ul></nav>';
        return html;
    }

    function bindClientPagerClicks(el) {
        el = el || ensurePager();
        if (!el) return;
        // Remove previous click handlers by cloning (simple way to avoid duplicates)
        const clone = el.cloneNode(true);
        el.parentNode.replaceChild(clone, el);
        clone.querySelectorAll('a[data-page]').forEach(a => {
            a.addEventListener('click', (e) => {
                e.preventDefault();
                showLoading();
                const p = parseInt(a.getAttribute('data-page') || '1', 10);
                if (p) loadArticles(p);
            });
        });
    }

    function bindServerPagerClicks(el) {
        if (!el) return;
        el.querySelectorAll('a').forEach(a => {
            a.addEventListener('click', (e) => {
                const href = a.getAttribute('href') || '';
                if (!href) return;
                try {
                    const u = new URL(href, location.origin);
                    if (!u.searchParams.has('page')) return;
                    e.preventDefault();
                    const p = parseInt(u.searchParams.get('page') || '1', 10) || 1;
                    showLoading();
                    loadArticles(p);
                    const listTop = document.getElementById('lh-list');
                    if (listTop) window.scrollTo({ top: listTop.offsetTop, behavior: 'smooth' });
                } catch (_) {
                }
            });
        });
    }

    function updateAllMetasFromNumbers(total, page, perPage) {
        const t  = Math.max(0, Number(total) || 0);
        const p  = Math.max(1, Number(page)  || 1);
        const pp = Math.max(1, Number(perPage) || 1);

        const s = t ? (p - 1) * pp + 1 : 0;
        const e = t ? Math.min(p * pp, t) : 0;

        const metas = document.querySelectorAll('.lh-meta');
        if (!metas.length) return;

        metas.forEach((el) => {
            el.setAttribute('data-start', String(s));
            el.setAttribute('data-end',   String(e));
            el.setAttribute('data-total', String(t));
            el.dataset.start = String(s);
            el.dataset.end   = String(e);
            el.dataset.total = String(t);
        });
    }

    // Client-side filtering for Search page
    function applyClientFiltersOnSearch(state) {
        if (!IS_SEARCH_PAGE || !gridEl) return { shown: 0 };
        const required = norm(REQUIRED_TAG || 'blog:Metagenics Institute');
        const wantTypes = (state.types || []).map(norm);
        const wantTopics = (state.topics || []).map(norm);
        const wantIngrs = (state.ingredients || []).map(norm);
        const wantAccess = !!state.access;

        const items = [...gridEl.querySelectorAll('li.lh-card-wrap[data-tags]')];
        let shown = 0;

        items.forEach(li => {
            const raw = (li.getAttribute('data-tags') || '').split('|').map(norm).filter(Boolean);
            // Enforce required blog tag across all blogs
            const okRequired = !required || raw.includes(required);

            // Optional facets
            const tTypes  = pick(raw, 'resource');
            const tTopics = pick(raw, 'topic');
            const tIngrs  = pick(raw, 'ingredient');
            const hasAccess = raw.includes('access:practitioner');

            const okType   = !wantTypes.length  || wantTypes.some(w => tTypes.includes(w));
            const okTopic  = !wantTopics.length || wantTopics.some(w => tTopics.includes(w));
            const okIngr   = !wantIngrs.length  || wantIngrs.some(w => tIngrs.includes(w));
            const okAcc    = !wantAccess        || hasAccess;

            const show = okRequired && okType && okTopic && okIngr && okAcc;

            li.dataset.lhMatch = show ? '1' : '0';
            if (show) shown += 1;
        });
        return { shown };
    }

    function clientPaginateAfterFilter(page){
        if (!gridEl) return { total: 0, page: 1, perPage: perPage };
        const pp = parseInt(document.getElementById('lh-list')?.dataset.perPage || String(perPage || 12), 10);

        const matches = [...gridEl.querySelectorAll('li.lh-card-wrap[data-tags]')]
            .filter(li => li.dataset.lhMatch === '1');

        const total = matches.length;
        const pages = Math.max(1, Math.ceil((total || 0) / (pp || 1)));
        const p = Math.max(1, Math.min(parseInt(page || 1, 10) || 1, pages));
        const start = (p - 1) * pp;
        const end = start + pp;

        const all = [...gridEl.querySelectorAll('li.lh-card-wrap[data-tags]')];
        all.forEach(li => { li.style.display = 'none'; li.hidden = true; });
        matches.forEach((li, idx) => {
            const show = idx >= start && idx < end;
            li.style.display = show ? '' : 'none';
            li.hidden = !show;
        });

        return { total, page: p, perPage: pp };
    }

    async function loadArticles(page = 1) {
        // Cancel any previous in-flight request and create a new controller
        const thisReqId = ++_requestState.id;
        if (_requestState.controller) {
            try { _requestState.controller.abort(); } catch (_) {}
        }
        _requestState.controller = new AbortController();
        const signal = _requestState.controller.signal;

        showLoading();
        const state = collectFilters();
        const hasText = !!state.q;
        const hasTagFilter = state.topics.length || state.ingredients.length || state.types.length || state.access;

        updateAddressBar(state, page);
        const hasBrandScope = !!REQUIRED_TAG; // when true, we must search across ALL blogs by tag
        const isSearch = IS_SEARCH_PAGE;
        const hasAnyFilter = !!state.q || state.types.length || state.topics.length || state.ingredients.length || state.access;

        if (isSearch && !hasAnyFilter) {
        // client-side filter only when there are NO filters/text
        const result = applyClientFiltersOnSearch(state);
        const meta = clientPaginateAfterFilter(page);
        pagerEl = ensurePager();
        if (pagerEl) {
            pagerEl.innerHTML = clientPagination(result.shown, meta.page, meta.perPage);
            bindClientPagerClicks(pagerEl);
        }
        updateAllMetasFromNumbers(result.shown, meta.page, meta.perPage);
        setCount(result.shown, meta.page, meta.perPage);
        updateAddressBar(state, page);
        hideLoading();
        return;
        }

        if (!hasText && !hasTagFilter && !hasBrandScope && !isSearch) {
            const params = new URLSearchParams();
            params.set('view', 'ajax');
            params.set('page', String(page));
            if (state.q) params.set('q', state.q);
            // Pass through required tag for server filtering
            if (REQUIRED_TAG) params.set('tag', REQUIRED_TAG);

            const {preview, section, storeBrand} = getEditorParams();
            if (preview) params.set('preview_theme_id', preview);
            if (section) params.set('section_id', section);
            if (storeBrand) params.set('store_brand', storeBrand);

            try {
                const url = `/blogs/${blogHandle}?${params.toString()}`;
                const res = await fetch(url, { credentials: 'same-origin', signal });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const html = await res.text();
                const tmp = document.createElement('div');
                tmp.innerHTML = html;
                if (thisReqId !== _requestState.id) return;

                const newGrid = tmp.querySelector('.lh-grid');
                const newPager = tmp.querySelector('.lh-pagination');
                const meta = tmp.querySelector('.lh-meta');

                if (gridEl) gridEl.innerHTML = newGrid ? newGrid.innerHTML : '<li style="grid-column:1/-1;padding:16px;text-align:center">No results.</li>';
                gridEl = document.querySelector('.lh-grid') || gridEl;
                pagerEl = document.querySelector('.lh-pagination') || pagerEl;
                ensureLoader();
                if (pagerEl) {
                    pagerEl.innerHTML = newPager ? newPager.innerHTML : '';
                    bindServerPagerClicks(pagerEl);
                }

                const firstMeta = tmp.querySelector('.lh-meta');
                if (firstMeta) {
                    const totalNum = parseInt(firstMeta.getAttribute('data-total') || '0', 10) || 0;
                    updateAllMetasFromNumbers(totalNum, page, perPage);
                    setCount(totalNum, page, perPage);
                } else {
                    updateAllMetasFromNumbers(0, 1, perPage);
                    setCount(0, 1, perPage);
                }

                pagerEl = document.querySelector('.lh-pagination') || pagerEl;
                updateAddressBar(state, page);
                if (thisReqId === _requestState.id) hideLoading();
            } catch (err) {
                if (err && err.name === 'AbortError') { return; }
                console.error('[LH] AJAX fast-path failed', err);
                // If we already have SSR or previous content, keep it; otherwise show a lightweight message
                if (gridEl && (!gridEl.children || gridEl.children.length === 0)) {
                    gridEl.innerHTML = '<li style="grid-column:1/-1;padding:16px;text-align:center">Failed to load. Try again.</li>';
                }
                if (thisReqId === _requestState.id) hideLoading();
            }
            return;
        }

        const qCombined = buildSearchQuery(state);

        const sURL = new URL('/search', location.origin);
        if (blogHandle) sURL.searchParams.set('blog', blogHandle);
        sURL.searchParams.set('view', 'lh-json');
        sURL.searchParams.set('type', 'article');
        sURL.searchParams.set('page', String(page));
        sURL.searchParams.set('limit', String(perPage || 12));
        if (REQUIRED_TAG) sURL.searchParams.set('tag', REQUIRED_TAG);
        if (state.topics.length) sURL.searchParams.set('topics', state.topics.join(','));
        if (state.ingredients.length) sURL.searchParams.set('ingredients', state.ingredients.join(','));
        if (state.types.length) sURL.searchParams.set('types', state.types.join(','));
        if (state.access) sURL.searchParams.set('access', 'practitioner');
        if (state.q) sURL.searchParams.set('q', state.q);
        
        console.log('[LH DEBUG] Search URL:', sURL.toString());
        console.log('[LH DEBUG] State:', state);

        const {preview, section} = getEditorParams();
        if (preview) sURL.searchParams.set('preview_theme_id', preview);
        if (section) sURL.searchParams.set('section_id', section);

        let handles = [];
        let total = 0;
        try {
            const sres = await fetch(sURL.toString(), { credentials: 'same-origin', signal });
            if (!sres.ok) throw new Error(`search HTTP ${sres.status}`);
            const sdata = await sres.json();
            const results = Array.isArray(sdata.results) ? sdata.results : [];

            // Use server's total_count if available, otherwise count filtered results
            total = sdata.total_count || results.length;
            
            // On a blog page we must stay within the same blog.
            // Filter out anything whose URL points to a different blog.
            const filtered = IS_SEARCH_PAGE ? results : results.filter(r => _blogFromUrl(r.url) === blogHandle);

            // Get handles from the filtered results (server already paginated)
            handles = filtered.map(r => r.handle).filter(Boolean);
        } catch (err) {
            if (err && err.name === 'AbortError') { return; }
            console.error('[LH] search failed', err);
            if (gridEl) gridEl.innerHTML = '<li style="grid-column:1/-1; padding:16px">No results.</li>';
            if (pagerEl) pagerEl.innerHTML = '';
            setCount(0, 1, perPage);
            updateAddressBar(state, page);
            hideLoading();
            return;
        }

        if (!handles.length) {
            if (gridEl) gridEl.innerHTML = '<li style="grid-column:1/-1; padding:16px">No results.</li>';
            if (pagerEl) pagerEl.innerHTML = '';
            setCount(0, 1, perPage);
            updateAddressBar(state, page);
            hideLoading();
            return;
        }

        const ajaxParams = new URLSearchParams();
        ajaxParams.set('view', 'ajax');
        ajaxParams.set('ids', handles.join(','));
        ajaxParams.set('total', String(total));
        // On the Search page force article scope and do NOT send q when rendering by ids
        if (IS_SEARCH_PAGE) {
            ajaxParams.set('type', 'article');
        } else if (state.q) {
            ajaxParams.set('q', state.q);
        }

        const ep = getEditorParams();
        if (ep.preview) ajaxParams.set('preview_theme_id', ep.preview);
        if (ep.section) ajaxParams.set('section_id', ep.section);
        if (ep.storeBrand) ajaxParams.set('store_brand', ep.storeBrand);

        try {
            const hasIds = ajaxParams.has('ids');
            // Cross-blog rendering ONLY on the Search page; elsewhere keep blog-scoped views
            const ajaxBase = IS_SEARCH_PAGE ? '/search' : (blogHandle ? `/blogs/${blogHandle}` : '/search');
            const ajaxUrl = `${ajaxBase}?${ajaxParams.toString()}`;
            const res = await fetch(ajaxUrl, { credentials: 'same-origin', signal });
            if (!res.ok) throw new Error(`render HTTP ${res.status}`);
            const html = await res.text();
            const tmp = document.createElement('div');
            tmp.innerHTML = html;


            const newGrid = tmp.querySelector('.lh-grid');
// Prefer only real cards; fall back to any LI with possible article markers
            let allLis = [];
            if (newGrid) {
                allLis = Array.from(newGrid.querySelectorAll('li.lh-card-wrap, li[data-article-tags], li[data-handle], li[data-article-handle]'));
            } else {
                allLis = Array.from(tmp.querySelectorAll('li.lh-card-wrap, li[data-article-tags], li[data-handle], li[data-article-handle]'));
            }

// Helpers to decode and extract handle from different DOM shapes
            const decodeMany = (s) => { let v = String(s || ''); for (let i=0;i<3;i++){ try{ const n = decodeURIComponent(v); if (n===v) break; v=n; }catch(_){ break; } } return v; };
            const textToHandle = (s) => decodeMany(String(s||'').split('#')[0].split('?')[0]).split('/').filter(Boolean).pop() || '';
            const handleFromLi = (li) => {
                if (!li) return '';
                // 1) explicit data attributes
                const d1 = li.getAttribute('data-handle');
                if (d1) return decodeMany(d1).toLowerCase();
                const d2 = li.getAttribute('data-article-handle');
                if (d2) return decodeMany(d2).toLowerCase();
                // 2) try anchor href
                const a = li.querySelector && li.querySelector('a[href]');
                if (a) {
                    let href = String(a.getAttribute('href') || '');
                    try { const u = new URL(href, location.origin); href = u.pathname || href; } catch(_) {}
                    const seg = textToHandle(href);
                    if (seg) return seg.toLowerCase();
                }
                // 3) try any data-href / data-url
                const d3 = li.getAttribute('data-href') || li.getAttribute('data-url');
                if (d3) return textToHandle(d3).toLowerCase();
                return '';
            };

// Build maps and sets for fast lookups
            const wanted = (handles || []).map(h => String(h || '').toLowerCase());
            const wantedSet = new Set(wanted);
            const byHandle = new Map();
            allLis.forEach(li => {
                const h = handleFromLi(li);
                if (h && !byHandle.has(h)) byHandle.set(h, li);
            });

// First pass: keep only items that match `handles` and preserve order
            let ordered = [];
            wanted.forEach(h => { const li = byHandle.get(h); if (li) ordered.push(li); });

// Second pass fallback: filter any items whose inferred handle is in wantedSet (if markup differs)
            if (!ordered.length && byHandle.size) {
                ordered = allLis.filter(li => wantedSet.has(handleFromLi(li))).slice(0, perPage);
            }

// Third pass fallback: take first N plausible article cards
            if (!ordered.length && allLis.length) {
                const plausible = allLis.filter(li => li.classList.contains('lh-card-wrap'));
                ordered = (plausible.length ? plausible : allLis).slice(0, perPage);
            }

// Enforce strict page size (12 by default)
            if (ordered.length > perPage) ordered = ordered.slice(0, perPage);

            if (gridEl && ordered.length) {
                gridEl.innerHTML = '';
                ordered.forEach(li => gridEl.appendChild(li));
            } else {
                console.warn('[LH] AJAX view returned no recognizable article items; keeping SSR grid intact');
                hideLoading();
                return;
            }

// Apply client-side filters only to already inserted cards; do not alter count/pager here
            applyClientFiltersOnSearch(state);

            // Keep Resource Type list aligned with current DOM but do not drop existing options
            if (!Array.isArray(FACETS.types) || !FACETS.types.length) {
                const currentList = getTypeLabelsFromList(typesBox);
                const domList = typesFromDOM(gridEl);
                const merged = unionTypes(currentList, domList);
                renderTypesChecklist(merged);
                // Re-apply CURRENT selection (not URL seed) so it doesn't flip back to "All"
                applyValuesWithAll(typesBox, state.types || []);
            }
            {
                const currentTopics = getTopicLabelsFromList(topicsBox);
                const domTopics = topicsFromDOM(gridEl);
                const mergedTopics = unionTypes(currentTopics, domTopics);
                renderTopicsChecklist(mergedTopics);
                applyValuesWithAll(topicsBox, state.topics || []);
            }
            // Nudge the ingredient autocomplete to use the latest DOM-derived list on next input
            try {
                const evt = new Event('input');
                const ingSearch = document.getElementById('f-ing-search');
                if (ingSearch) ingSearch.dispatchEvent(evt);
            } catch(_) {}

            gridEl = document.querySelector('.lh-grid') || gridEl;
            pagerEl = document.querySelector('.lh-pagination') || pagerEl;
            ensureLoader();

            pagerEl = ensurePager();
            if (pagerEl) {
                pagerEl.innerHTML = clientPagination(total, page, perPage);
                bindClientPagerClicks(pagerEl);
            }

            updateAllMetasFromNumbers(total, page, perPage);
            setCount(total, page, perPage);
            updateAddressBar(state, page);
            if (thisReqId === _requestState.id) hideLoading();

        } catch (err) {
            if (err && err.name === 'AbortError') { return; }
            console.error('[LH] AJAX render failed', err);
            // If we already have SSR or previous content, keep it; otherwise show a lightweight message
            if (gridEl && (!gridEl.children || gridEl.children.length === 0)) {
                gridEl.innerHTML = '<li style="grid-column:1/-1;padding:16px;text-align:center">Failed to load. Try again.</li>';
            }
            if (thisReqId === _requestState.id) hideLoading();
        }
    }

    (function seedCountFromSSR() {
        const metaEls = document.querySelectorAll('.lh-meta');
        console.log('[LH] seedCountFromSSR found metas:', metaEls.length);

        if (!metaEls.length) return;

        const firstMeta = metaEls[0];
        const s = parseInt(firstMeta.dataset.start || firstMeta.getAttribute('data-start') || '0', 10);
        const e = parseInt(firstMeta.dataset.end || firstMeta.getAttribute('data-end') || '0', 10);
        const t = parseInt(firstMeta.dataset.total || firstMeta.getAttribute('data-total') || '0', 10);

        const pageFromStart = s ? (Math.floor((s - 1) / perPage) + 1) : 1;
        setCount(t, pageFromStart, perPage);

        updateAllMetasFromNumbers(t, pageFromStart, perPage);
    })();

    let _filtersChangeTimer = null;
    if (filtersPanel) {
        filtersPanel.addEventListener('change', (e) => {
            if (pageType === 'education') return;
            const el = e.target;
            if (!el) return;
            if (el.tagName === 'INPUT' || el.tagName === 'SELECT' || el.tagName === 'TEXTAREA') {

                const state = collectFilters();
                updateAddressBar(state, 1);

                clearTimeout(_filtersChangeTimer);
                _filtersChangeTimer = setTimeout(() => {
                    renderActiveChips();
                    if (IS_SEARCH_PAGE) {
                        // Apply client filter instantly while new request is in-flight
                        try { applyClientFiltersOnSearch(collectFilters()); } catch(_) {}
                    }
                    loadArticles(1);
                }, 300);
            }
        });
    }
    const searchForm = document.getElementById('lh-search');
    if (searchForm) {
        searchForm.addEventListener('submit', (e) => {
            e.preventDefault();
            loadArticles(1);
        });
    }

    const init = syncFromURL();
    renderActiveChips();
    if (init && init.hasAny) {
        loadArticles(init.page);
    } else if (!gridEl || !gridEl.children || gridEl.children.length === 0) {
        loadArticles(1);
    }

});